module.exports = __webpack_public_path__ + "media/application/images/svgs/list-8086623cc49767eb6ef48a5ae0cf73ed.svg";